import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types'; // Super simple output of nav items
//  TODO:
//  - propTypes
//  - build out components for ListItem, Link, Submenu, etc
//  - default styling

export default function NavItem(_ref) {
  var className = _ref.className,
      data = _ref.data,
      _ref$props = _ref.props,
      props = _ref$props === void 0 ? {} : _ref$props,
      rest = _objectWithoutProperties(_ref, ["className", "data", "props"]);

  var gaLabel = data.gaLabel || data.label;
  var gaCategory = props.gaCategory || '';
  var gaAction = props.gaAction || '';

  var renderSubMenu = data => {
    if (data.navItems) {
      return /*#__PURE__*/React.createElement("ul", {
        "data-nav-handle": data.handle
      }, data.navItems.map((item, index) => {
        return /*#__PURE__*/React.createElement(NavItem, {
          data: item,
          key: index,
          props: props
        });
      }));
    }
  };

  return /*#__PURE__*/React.createElement("li", {
    className: data.label,
    "data-ga-category": gaCategory,
    "data-ga-action": gaAction,
    "data-ga-label": gaLabel
  }, /*#__PURE__*/React.createElement("a", {
    href: data.url
  }, data.label), renderSubMenu(data));
}
NavItem.propTypes = {
  className: PropTypes.string,
  data: PropTypes.object,
  // TODO: Make more strict.
  gaAction: PropTypes.string,
  gaCategory: PropTypes.string,
  props: PropTypes.object
};